import React, { useState, useEffect, useContext, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import FleetOptionsDialog from '../Dialog/FleetsDialog/FleetsDialog';
import axios from '../../api/axios';
import { store } from '../../store';
import Skeleton from '../OtherElements/CustomSkeleton';
import InputAdornment from '@material-ui/core/InputAdornment';
import loadTypesIcon from '../../assets/svg/loadTypes.svg';
import { useQuery } from 'react-query';

const FleetsTextField = ({
  onChange,
  selection,
  single = false,
  title = 'انتخاب ناوگان',
  error = false,
  weight = 0,
  weightType = 'Ton',
  size = 'medium',
  ...rest
}) => {
  const { showMessage, showError } = useContext(store);
  const [values, setValues] = useState({
    fleets: null,
    fleetOptionsDialog: false,
  });

  const handleShowFleetDialog = () => {
    if (single && selection.length) {
      onChange([]);
    }
    setValues({ ...values, fleetOptionsDialog: true });
  };
  const handleCloseFleetDialog = (fleets) => {
    setValues({ ...values, fleetOptionsDialog: false });
    onChange(fleets);
  };
  const loadFleets = async () => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/fleet?weight=${
          weightType === 'Ton' ? weight : weight / 1000
        }`
      );
      return data;
      setValues({ ...values, fleets: data });
    } catch (error) {
      showError('بروز خطا در واکاوی از دیتابیس');
    }
  };

  const ar = selection.map((fl) => `${fl?.fleet?.title}(${fl?.title})`);
  const fleetsString = ar?.join(' - ');

  // useEffect(() => {
  //   loadFleets();
  // }, [weight, weightType]);

  const { data, isLoading } = useQuery(
    ['loadFleets', weight, weightType],
    () => loadFleets(),
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24 * 30,
    }
  );

  return (
    <Fragment>
      {values.fleetOptionsDialog ? (
        <FleetOptionsDialog
          fleets={data}
          onClose={handleCloseFleetDialog}
          checkedFleets={selection ? selection : []}
          single={single}
        />
      ) : null}
      {!isLoading ? (
        <TextField
          size={size}
          error={error}
          fullWidth
          name="fleetOption"
          label={title}
          variant="outlined"
          onChange={null}
          value={fleetsString}
          multiline={!single}
          onClick={handleShowFleetDialog}
          helperText={error ? 'انتخاب ناوگان اجباری است' : ''}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src={loadTypesIcon} alt="" height={40} width={40} />
              </InputAdornment>
            ),
          }}
          {...rest}
        />
      ) : (
        <Skeleton height={100} />
      )}
    </Fragment>
  );
};

export default React.memo(FleetsTextField);
